var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterface2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.17 81.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9caab2;}.cls-2{fill:#b8bcc0;}.cls-3{fill:#ccd6e5;}.cls-4{fill:#8ab3ff;}.cls-5{fill:#343f42;}.cls-6{fill:#588df0;}.cls-13,.cls-7{fill:none;stroke-miterlimit:10;}.cls-7{stroke:#588df0;}.cls-8{fill:#828282;}.cls-9{fill:#303b3e;}.cls-10{fill:#f44d4d;}.cls-11{fill:#f66562;}.cls-12{fill:#d0d6e2;}.cls-13{stroke:#303b3e;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_01a",
    "data-name": "Interface_01a",
    viewBox: "0 0 63.17 81.96"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.2 33.96 0 3.24 0 51.24 53.2 81.96 53.2 33.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.2 33.96 63.17 30.71 63.17 78.72 53.2 81.96 53.2 33.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 3.24 53.2 33.96 63.17 30.71 9.97 0 0 3.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "17.63 54.26 17.63 26.57 48.87 44.61 48.87 72.3 17.63 54.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.62,28.3,47.87,45.19V70.57L18.62,53.68V28.3m-2-3.46v30L49.87,74V44L16.62,24.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "29.93 38.49 19.95 32.76 19.95 50.76 29.93 56.49 29.93 38.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 46.55,
    y1: 48.07,
    x2: 33.25,
    y2: 40.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 46.55,
    y1: 54.12,
    x2: 33.25,
    y2: 46.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 46.55,
    y1: 60.12,
    x2: 33.25,
    y2: 52.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 46.55,
    y1: 66.12,
    x2: 33.25,
    y2: 58.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "13.3 22.89 13.3 52.89 3.33 47.16 3.33 17.16 13.3 22.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.05,39.43a2.06,2.06,0,0,0,2.74-2.14,6.16,6.16,0,0,0-3.06-4.85A3.68,3.68,0,0,0,45.67,32a2.06,2.06,0,0,0-2.74,2.13A6.19,6.19,0,0,0,46,39,3.92,3.92,0,0,0,47.05,39.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41.56,34.3l3.2-1a1.77,1.77,0,0,1,1.6.23A4.59,4.59,0,0,1,48.59,37a1.24,1.24,0,0,1-.52,1.12s-3.49,1.18-3.59,1.2A1.88,1.88,0,0,1,43,39a4.62,4.62,0,0,1-2.23-3.52A1.14,1.14,0,0,1,41.56,34.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 43.04,
    cy: 36.81,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-13.48 33.3) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.08,33.7a2.06,2.06,0,0,0,2.74-2.13,6.19,6.19,0,0,0-3.06-4.86,4.12,4.12,0,0,0-1.06-.44A2.06,2.06,0,0,0,33,28.41,6.19,6.19,0,0,0,36,33.27,3.94,3.94,0,0,0,37.08,33.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M31.58,28.57l3.21-1.05a1.78,1.78,0,0,1,1.6.24,4.6,4.6,0,0,1,2.23,3.51,1.23,1.23,0,0,1-.53,1.12s-3.49,1.18-3.58,1.2a1.87,1.87,0,0,1-1.45-.28,4.62,4.62,0,0,1-2.23-3.51A1.18,1.18,0,0,1,31.58,28.57Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 33.06,
    cy: 31.08,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-12.04 26.15) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29,28.77a1.83,1.83,0,0,0,2.44-1.91,5.83,5.83,0,0,0-2.85-4.52,3.76,3.76,0,0,0-1-.4,1.82,1.82,0,0,0-2.44,1.91A5.83,5.83,0,0,0,28,28.37,3.76,3.76,0,0,0,29,28.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 28.32,
    cy: 25.35,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-9.56 22.14) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.36,25A1.82,1.82,0,0,0,24.8,23,5.83,5.83,0,0,0,22,18.52a3.76,3.76,0,0,0-1-.4A1.83,1.83,0,0,0,18.54,20a5.83,5.83,0,0,0,2.85,4.52A3.76,3.76,0,0,0,22.36,25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 21.67,
    cy: 21.54,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-8.6 17.37) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.71,21.13a1.82,1.82,0,0,0,2.44-1.91A5.83,5.83,0,0,0,15.3,14.7a3.76,3.76,0,0,0-1-.4,1.83,1.83,0,0,0-2.44,1.91,5.83,5.83,0,0,0,2.85,4.52A3.44,3.44,0,0,0,15.71,21.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 15.02,
    cy: 17.72,
    rx: 1.68,
    ry: 2.96,
    transform: "matrix(0.8, -0.6, 0.6, 0.8, -7.64, 12.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.84,29.21a1.83,1.83,0,0,0,2.45-1.91,5.84,5.84,0,0,0-2.86-4.52,3.7,3.7,0,0,0-1-.4A1.83,1.83,0,0,0,5,24.29a5.84,5.84,0,0,0,2.86,4.52A3.7,3.7,0,0,0,8.84,29.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 8.15,
    cy: 25.8,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-13.88 10.1) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.84,38.21a1.83,1.83,0,0,0,2.45-1.91,5.84,5.84,0,0,0-2.86-4.52,3.7,3.7,0,0,0-1-.4A1.83,1.83,0,0,0,5,33.29a5.84,5.84,0,0,0,2.86,4.52A3.7,3.7,0,0,0,8.84,38.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 8.15,
    cy: 34.8,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-19.29 11.91) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.84,47.21a1.83,1.83,0,0,0,2.45-1.91,5.84,5.84,0,0,0-2.86-4.52,3.7,3.7,0,0,0-1-.4A1.83,1.83,0,0,0,5,42.29a5.84,5.84,0,0,0,2.86,4.52A3.7,3.7,0,0,0,8.84,47.21Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 8.15,
    cy: 43.8,
    rx: 1.68,
    ry: 2.96,
    transform: "translate(-24.71 13.72) rotate(-36.99)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 11.67,
    y1: 32.51,
    x2: 5.02,
    y2: 28.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 11.67,
    y1: 41.34,
    x2: 5.02,
    y2: 37.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 11.67,
    y1: 50.47,
    x2: 5.02,
    y2: 46.65
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 63.17,
    height: 81.96,
    xlinkHref: "#Interface_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface2);
export default __webpack_public_path__ + "static/media/interface-2.0976e00ce68b8bef23fee48658a6b74a.svg";
export { ForwardRef as ReactComponent };